// Theme definitions and picker logic

const STORAGE_KEY = 'chaos-chess-theme'

// Each swatch background shows dark square (left) → light square (right)
export const THEMES = [
  { id: 'classic',  label: 'Classic',  swatch: 'linear-gradient(135deg, #8b5e3c 50%, #f0d9b5 50%)' },
  { id: 'midnight', label: 'Midnight', swatch: 'linear-gradient(135deg, #1e1e30 50%, #5a5a78 50%)' },
  { id: 'forest',   label: 'Forest',   swatch: 'linear-gradient(135deg, #4a7038 50%, #cce4a8 50%)' },
  { id: 'ocean',    label: 'Ocean',    swatch: 'linear-gradient(135deg, #286888 50%, #b0d0e8 50%)' },
  { id: 'royal',    label: 'Royal',    swatch: 'linear-gradient(135deg, #6b3828 50%, #f2e6c0 50%)' },
]

function applyTheme(id: string) {
  if (id === 'classic') {
    document.documentElement.removeAttribute('data-theme')
  } else {
    document.documentElement.setAttribute('data-theme', id)
  }
  localStorage.setItem(STORAGE_KEY, id)
  syncActiveClass(id)
}

function syncActiveClass(id: string) {
  document.querySelectorAll<HTMLElement>('.theme-swatch').forEach(btn => {
    btn.classList.toggle('active', btn.dataset['themeId'] === id)
  })
}

export function initTheme() {
  const saved = localStorage.getItem(STORAGE_KEY) ?? 'classic'
  applyTheme(saved)
}

export function attachThemeListeners() {
  const current = localStorage.getItem(STORAGE_KEY) ?? 'classic'
  document.querySelectorAll<HTMLElement>('.theme-swatch').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.dataset['themeId']
      if (id) applyTheme(id)
    })
  })
  syncActiveClass(current)
}
